import { getPermissions } from '../utils/mainUtils'
import * as ActionTypes from './actionTypes'

export const loginSuccess = token => ({
    type: ActionTypes.LOGIN_SUCCESS,
    payload: {
        token: {
            ...token,
            permissions: getPermissions(token),
            time: +new Date()
        }
    }
})

export const loginFailure = error => ({
    type: ActionTypes.LOGIN_FAILURE,
    payload: {
        status: error.response.status,
        statusText: error.response.statusText
    }
})

export const logout = () => ({
    type: ActionTypes.LOGOUT
})



// WEBPACK FOOTER //
// ./src/actions/authActions.js